// services/atualizarCotaUsuario.ts
// --------------------- Import Global ---------------------
import axios from "axios";
import Globais, { validateToken } from "../../../components/Globais";
// --------------------- Import Interface ---------------------
import { CotaUsuario } from "../interfaces/CotaUsuario";

const normalizarNumero = (valor: number | string | undefined) => {
  if (valor === undefined || valor === "") return valor;

  const numero = Number(valor);
  return Number.isNaN(numero) ? valor : numero;
};

const normalizarBooleano = (valor: boolean | number | string | undefined) => {
  if (valor === undefined) return valor;

  return valor === true || valor === 1 || valor === "1" || valor === "true";
};

export const atualizarCotaUsuario = async (
  cotaUsuarioId: number | undefined | null,
  valuesMaisInfo: CotaUsuario
) => {
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/cota-usuario/${cotaUsuarioId}`;
    const payload = {
      ...valuesMaisInfo,
      aceitaTroca: normalizarBooleano(valuesMaisInfo.aceitaTroca),
      saldoDevedor: normalizarNumero(valuesMaisInfo.saldoDevedor),
      valorCondominio: normalizarNumero(valuesMaisInfo.valorCondominio),
      valorVenda: normalizarNumero(valuesMaisInfo.valorVenda),
    };

    try {
      console.log(
        "[Gerenciar anúncio de venda] Valor de venda enviado ao backend:",
        payload.valorVenda
      );
      console.log("[Gerenciar anúncio de venda] Payload enviado ao backend", {
        url: URL,
        payload,
      });
      const response = await axios.put(URL, payload, {
        headers: { Authorization: Token.AuthStr },
      });
      if (response && response.data) {
        return response.data;
      }
    } catch (error) {
      console.error(error);
    }
  }
};
